import { render, staticRenderFns } from "./ReportSyntheticCredit.vue?vue&type=template&id=fd449ae2&"
import script from "./ReportSyntheticCredit.vue?vue&type=script&lang=js&"
export * from "./ReportSyntheticCredit.vue?vue&type=script&lang=js&"
import style0 from "./ReportSyntheticCredit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports